import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg, LEVELS } from "@/lib/api";

const EMPTY = { company: "", title: "", url: "", level: "", location: "", date_posted: "", full_text: "" };
const inp = "w-full bg-slate-900 border border-border rounded-md px-3 py-2 text-sm outline-none focus:border-blue-500";

export default function ManualJD({ open, onClose, jobId, onAdded }) {
  const [f, setF] = useState(EMPTY);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    if (!f.company || !f.title || f.full_text.length < 100) return toast.error("Company, title and the full JD text are required");
    try { await api.post(`/jobs/${jobId}/jds`, f); toast.success("JD added. Click 'Re-check JDs' to process."); setF(EMPTY); onAdded(); onClose(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl bg-card" data-testid="manual-jd-dialog">
        <DialogHeader><DialogTitle>Paste a job description</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <input data-testid="manual-jd-company" className={inp} placeholder="Company" value={f.company} onChange={set("company")} />
          <input data-testid="manual-jd-title" className={inp} placeholder="Title" value={f.title} onChange={set("title")} />
          <input className={inp} placeholder="URL" value={f.url} onChange={set("url")} />
          <select className={inp} value={f.level} onChange={set("level")}><option value="">Level (optional)</option>{LEVELS.map((l) => <option key={l}>{l}</option>)}</select>
          <input className={inp} placeholder="Location" value={f.location} onChange={set("location")} />
          <input className={inp} type="date" value={f.date_posted} onChange={set("date_posted")} />
        </div>
        <textarea data-testid="manual-jd-text" className={`${inp} min-h-[220px]`} placeholder="Full JD text" value={f.full_text} onChange={set("full_text")} />
        <Button data-testid="manual-jd-save" onClick={save} className="bg-blue-600 hover:bg-blue-500 text-white">Add JD</Button>
      </DialogContent>
    </Dialog>
  );
}
